import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TextWithAudioIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 32.748 26.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 26.5),
    children: [/*#__PURE__*/jsx("path", {
      d: "M2.833 23.666A2.083 2.083 0 01.75 21.583v-4.167a2.083 2.083 0 012.083-2.083 2.083 2.083 0 012.083 2.083v4.167a2.083 2.083 0 01-2.083 2.083zM29.915 23.666a2.083 2.083 0 01-2.083-2.083v-4.167a2.083 2.083 0 012.083-2.083 2.083 2.083 0 012.083 2.083v4.167a2.083 2.083 0 01-2.083 2.083zM27.831 17.416v-5.208A11.491 11.491 0 0016.374.75 11.492 11.492 0 004.916 12.208v5.208"
    }), /*#__PURE__*/jsx("rect", {
      width: "14.583",
      height: "16.666",
      x: "9.083",
      y: "9.084",
      rx: ".75"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.374 13.251h3.125M13.249 17.417h6.25M13.249 21.584h6.25"
    })]
  });
};

export { PM2TextWithAudioIcon };
//# sourceMappingURL=text-with-audio.js.map
